var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05025 0.635667C1.65972 0.245142 1.02656 0.245142 0.636033 0.635667C0.245509 1.02619 0.245509 1.65936 0.636033 2.04988L5.58579 6.99963L0.636045 11.9494C0.245521 12.3399 0.245521 12.9731 0.636045 13.3636C1.02657 13.7541 1.65973 13.7541 2.05026 13.3636L7 8.41385L11.9497 13.3636C12.3403 13.7541 12.9734 13.7541 13.364 13.3636C13.7545 12.9731 13.7545 12.3399 13.364 11.9494L8.41421 6.99963L13.364 2.04988C13.7545 1.65936 13.7545 1.02619 13.364 0.635667C12.9734 0.245142 12.3403 0.245142 11.9498 0.635667L7 5.58542L2.05025 0.635667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/CancelIcon.a5b1976a.svg";
export { ForwardRef as ReactComponent };